// import React from "react";
// import { Link } from "react-router-dom";

// const Bag = () => {
//   return (
//     <div>
//       <div className="bag-section container-fluid">
//         <div className="bagheader">
//           <div className="nav-logo">
//             <Link to="/">
//               <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
//             </Link>
//           </div>
//           <div className="headerCenter">
//             <Link to="/bag">BAG -------- </Link>
//             <Link to="/address">
//               {" "}
//               ADDRESS --------{" "}
//             </Link>
//             <Link to="/payment">PAYMENT</Link>
//           </div>
//           <div className="headerRight">
//             <img
//               className="image2"
//               src="https://constant.myntassets.com/checkout/assets/img/sprite-secure.png"
//             />
//             <span> 100% SECURE</span>
//           </div>
//         </div>
//       </div>

//       <div className="container bag-container">
//         <div className="row bag-main">
//           <div className="col-lg-7 col-md-7 col-sm-12 center" id="center">
//             <div className="container4">
//               <h5>Available Offer</h5>
//               <p>
//                 . 10% Instant Discount on SBI Credit Cards on a minimum spend of
//                 Rs 3000. TCA
//                 <br />
//                 <span id="more">
//                   . 5% Unlimited Cashback on Flipkart Axis Bank Ctedit Card TCA
//                   <br />
//                   <br />
//                   . 10% Cashback upto Rs 250 on a minimum spend of Rs 1500 with
//                   PayZapp TCA
//                   <br />
//                   <br />
//                   . Upto Rs 500 Cashback on Mobikwik wallet transaction of min
//                   Rs 999. Use code MBK500 on mobikwik TCA
//                   <br />
//                   <br />. Flat Rs 200 Cashback on first Airtel Payments Bank
//                   transcation on myntra on a min spend of Rs 2000 TCA
//                 </span>
//               </p>
//               <button onclick="showMore()" id="myBtn">
//                 Show More
//               </button>
//             </div>

//             <div className="total">
//               <h3
//                 style={{
//                   float: "left",
//                   fontSize: "larger",
//                   color: "black",
//                   fontWeight: 700,
//                 }}
//               >
//                 My Shopping Bag(1 item)
//               </h3>
//               <h3
//                 style={{
//                   float: "right",
//                   fontSize: "larger",
//                   color: "black",
//                   fontWeight: 700,
//                 }}
//               >
//                 Total: Rs. 421
//               </h3>
//             </div>

//             <div className="par">
//               <div id="addImages">
//                 <img
//                   id="img2"
//                   src="https://assets.myntassets.com/h_1440,q_100,w_1080/v1/assets/images/2378362/2018/6/9/270e0a7e-365b-4640-9433-b269c60bf3061528527188563-Moda-Rapido-Men-Maroon-Printed-Round-Neck-T-shirt-3811528527-1.jpg"
//                 />
//                 <div className="child">
//                   <p className="para">
//                     Moda Rapido
//                     <br />
//                     Men Maroon Printed Round Neck T-shirt <br />
//                     <small>Sold By : Vision Star</small>
//                   </p>
//                   <p />
//                   <select name="size" id="size">
//                     <option value="SIZE:L">SIZE: L</option>
//                     <option value="SIZE:M">SIZE: M</option>
//                     <option value="SIZE:S">SIZE: S</option>
//                     <option value="SIZE:Xl">SIZE: XL</option>
//                   </select>
//                   <select name="quantity" id="quantity">
//                     <option value={1}>Qty: 1</option>
//                     <option value={2}>2</option>
//                     <option value={3}>3</option>
//                     <option value={4}>4</option>
//                     <option value={5}>5</option>
//                     <option value={6}>6</option>
//                     <option value={7}>7</option>
//                     <option value={8}>8</option>
//                     <option value={9}>9</option>
//                     <option value={10}>10</option>
//                   </select>
//                   <p id="discount">
//                     <span className="price">Rs. 421</span>
//                     <s>Rs649</s>
//                     <span className="discount-off">25 % off</span>
//                   </p>
//                 </div>
//                 <div></div>
//               </div>
//             </div>
//           </div>

//           <div
//             className="col-lg-5 col-md-5 col-sm-12 placeOrder"
//             id="placeOrder"
//           >
//             <div className="placeOrder">
//               <div className="grid-placeOrder">
//                 {/* COUPONS */}
//                 <p className="section-title">COUPONS</p>
//                 <div className="coupon-row">
//                   <span>
//                     <b>Apply Coupons</b>
//                   </span>
//                   <button className="apply-btn">APPLY</button>
//                 </div>
//                 <hr />

//                 {/* GIFTING */}
//                 <p className="section-title">GIFTING & PERSONALISATION</p>
//                 <div className="gift-box">
//                   {/* <img src="img/ribbon.avif" alt="Gift" /> */}
//                   <div>
//                     <p>
//                       <b>Buying for a loved one?</b>
//                     </p>
//                     <p className="subtext">
//                       Gift Packaging and personalised message on card, Only for
//                       ₹35
//                     </p>
//                     <button className="add-gift-btn">ADD GIFT PACKAGE</button>
//                   </div>
//                 </div>
//                 <hr />

//                 {/* DONATION */}
//                 <p className="section-title">
//                   SUPPORT TRANSFORMATIVE SOCIAL WORK IN INDIA
//                 </p>
//                 <label className="donate-label">
//                   <input type="checkbox" />
//                   <span>Donate and make a difference</span>
//                 </label>
//                 <div className="donation-buttons">
//                   {[10, 20, 50, 100].map((amt) => (
//                     <button key={amt} className="donate-chip">
//                       ₹{amt}
//                     </button>
//                   ))}
//                 </div>
//                 <p className="know-more">Know More</p>
//                 <hr />

//                 {/* PRICE DETAILS */}
//                 <p className="section-title">PRICE DETAILS (1 Item)</p>
//                 <div className="price-row">
//                   <span>Total MRP</span>
//                   <span>₹1,999</span>
//                 </div>
//                 <div className="price-row">
//                   <span>
//                     Discount on MRP <span className="know-more">Know More</span>
//                   </span>
//                   <span className="green">-₹1,500</span>
//                 </div>
//                 <div className="price-row">
//                   <span>Coupon Discount</span>
//                   <button className="coupon-link">Apply Coupon</button>
//                 </div>
//                 <div className="price-row">
//                   <span>
//                     Platform Fee <span className="know-more">Know More</span>
//                   </span>
//                   <span>
//                     <s>₹99</s> Free
//                   </span>
//                 </div>
//                 <hr />
//                 <div className="price-row total">
//                   <span>Total Amount</span>
//                   <span>₹499</span>
//                 </div>
//                   <Link to="/address">
//                 <button className="place-order-btn">PLACE ORDER</button>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div>
//             <hr className="horizontal" />
//             <div>
//               <h5>You May Also Like:</h5>
//               <button className="myBtn2">All</button>
//               <button
//                 className="myBtn2"
//                 onselect="showSocks()"
//                 style={{ marginLeft: 5 }}
//               >
//                 Scocks
//               </button>
//               <button
//                 className="myBtn2"
//                 onmouseover="showScarves()"
//                 style={{ marginLeft: 5 }}
//               >
//                 Scarves
//               </button>
//               <div id="gridContainer"></div>
//             </div>
//           </div>
//           <div className="bagfooter">
//             <div className="container3">
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-ssl.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-visa.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-mc.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-ae.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-dc.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-nb.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-cod.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-rupay.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-paypal.png"
//               />
//               <img
//                 className="images"
//                 src="https://constant.myntassets.com/checkout/assets/img/footer-bank-bhim.png"
//               />
//             </div>
//             <a className="contact" href="">
//               <span>Need Help? Contact Us</span>
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Bag;



import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getGuestCart, saveGuestCart } from "../utils/guestStorage";
import LoginModal from "./loginmodel";

const Bag = () => {
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingCartId, setUpdatingCartId] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false); 
  const [customQtyMap, setCustomQtyMap] = useState({});
  const [customModeMap, setCustomModeMap] = useState({});


  // Size & color mapping
  const [sizeMap, setSizeMap] = useState({});
  const [colorMap, setColorMap] = useState({});
  
  // Price details from API
  const [subtotal, setSubtotal] = useState("0.00");
  const [totalDiscount, setTotalDiscount] = useState("0.00");
  const [grandTotal, setGrandTotal] = useState("0.00");

  const navigate = useNavigate();

  useEffect(() => {
    fetchCart();
    fetchSizeList();
    fetchColorList();
  }, []);

  // FETCH SIZE LIST
  const fetchSizeList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
      );

      if (res.data?.status) {
        const map = {};
        res.data.row.forEach((item) => {
          map[item.size_id] = item.size_label;
        });
        setSizeMap(map);
      }
    } catch (err) {
      console.error("Size Fetch Error:", err);
    }
  };

  // FETCH COLOR LIST
  const fetchColorList = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
      );

      if (res.data?.status) {
        const map = {};
        res.data.colors.forEach((item) => {
          map[item.color_id] = item.color_name;
        });
        setColorMap(map);
      }
    } catch (err) {
      console.error("Color Fetch Error:", err);
    }
  };

  // FETCH CART LIST
  const fetchCart = async () => {
    const userId = localStorage.getItem("user_id");

    // GUEST USER
    if (!userId) {
      const guestCart = getGuestCart();

      setCart(
        guestCart.map((item, index) => ({
          ...item,
          cart_id: index + 1,
          qty: item.cart_qty,
          current_price: item.price,
          old_price: item.old_price || item.price,
          multi_image: [item.image],
        }))
      );

      const sub = guestCart.reduce(
        (sum, i) => sum + i.price * i.cart_qty,
        0
      );

      setSubtotal(sub.toFixed(2));
      setTotalDiscount("0.00");
      setGrandTotal(sub.toFixed(2));
      setLoading(false);
      return;
    }

    // LOGGED-IN USER
    try {
      let formData = new FormData();
      formData.append("user_id", userId);

      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_cart",
        formData
      );

      if (res.data?.status === true || res.data?.status === "true") {
        setCart(res.data.data);
        setSubtotal(res.data.subtotal || "0.00");
        setTotalDiscount(res.data.total_discount || "0.00");
        setGrandTotal(res.data.grand_total || "0.00");
      }
    } catch (error) {
      console.error("Cart Fetch Error:", error);
    }

    setLoading(false);
  };

  // UPDATE CART QUANTITY
  const updateCartQuantity = async (cartId, newQty) => {
    const userId = localStorage.getItem("user_id");

    // GUEST
    if (!userId) {
      const guestCart = getGuestCart();

      const updated = guestCart.map((item, index) =>
        index + 1 === cartId
          ? { ...item, cart_qty: Number(newQty) }
          : item
      );

      saveGuestCart(updated);
      fetchCart();
      return;
    }

    // USER
    try {
      let formData = new FormData();
      formData.append("cart_id", cartId);
      formData.append("qty", newQty);

      await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_cart",
        formData
      );

      fetchCart();
    } catch (err) {
      console.error(err);
    }
  };

  // DELETE CART ITEM
  const deleteCartItem = async (cartId) => {
    const userId = localStorage.getItem("user_id");

    // GUEST
    if (!userId) {
      const guestCart = getGuestCart();
      const updated = guestCart.filter(
        (_, index) => index + 1 !== cartId
      );

      saveGuestCart(updated);
      fetchCart();
      toast.success("Item removed");
      return;
    }

    // USER
    try {
      let formData = new FormData();
      formData.append("user_id", userId);
      formData.append("cart_id", cartId);

      await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_cart",
        formData
      );

      fetchCart();
    } catch (err) {
      console.error(err);
    }
  };

  // HANDLE CONTINUE - NOW OPENS MODAL INSTEAD OF ALERT
  const handleContinue = () => {
    const userId = localStorage.getItem("user_id");

    if (!userId) {
      setShowLoginModal(true); // Open modal instead of alert
      return;
    }
    navigate("/address");
  };

  // HANDLE MODAL CLOSE - RELOAD CART IF LOGIN WAS SUCCESSFUL
  const handleModalClose = (loginSuccess = false) => {
    setShowLoginModal(false);
    if (loginSuccess) {
      fetchCart(); // Reload cart after successful login
      setTimeout(() => {
        navigate("/address"); // Navigate after cart is synced
      }, 500);
    }
  };

  if (loading) return <h3>Loading Cart...</h3>;

  return (
    <div>
      {/* LOGIN MODAL */}
      <LoginModal isOpen={showLoginModal} onClose={handleModalClose} />

      {/* HEADER */}
      <div className="bag-section container-fluid">
        <div className="bagheader">
          <div className="nav-logo">
            <Link to="/">
              <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
            </Link>
          </div>

          <div className="headerCenter">
            <Link to="/bag">BAG -------- </Link>
            <Link to="/address"> ADDRESS -------- </Link>
            <Link to="/payment">PAYMENT</Link>
          </div>

          <div className="headerRight">
            <img
              className="image2"
              src="https://constant.myntassets.com/checkout/assets/img/sprite-secure.png"
            />
            <span> 100% SECURE</span>
          </div>
        </div>
      </div>

      <div className="container bag-container">
        <div className="row bag-main">
          {/* LEFT SIDE */}
          <div className="col-lg-7 col-md-7 col-sm-12 center" id="center">
            <div className="container4">
              <h5>Available Offer</h5>
              <p>
                . 10% Instant Discount on SBI Credit Cards on min spend Rs 3000
                <br />
                . 5% Unlimited Cashback on Flipkart Axis Bank Card
              </p>
            </div>

            <div className="total">
              <h3 style={{ float: "left", fontWeight: 700 }}>
                My Shopping Bag({cart.length} item)
              </h3>
            </div>

            {/* CART ITEMS */}
            {cart.map((item) => (
              <div className="par" key={item.cart_id} style={{ position: "relative" }}>
                {/* DELETE BUTTON */}
                <button
                  onClick={() => deleteCartItem(item.cart_id)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "none",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "#333",
                    fontWeight: "bold",
                    zIndex: 10
                  }}
                  title="Remove item"
                >
                  ✕
                </button>

                <div id="addImages">
                  <img
                    id="img2"
                    src={
                      item.multi_image?.length > 0
                        ? `https://cyberathon.com/multivendor/${item.multi_image[0]}`
                        : item.multi_image
                          ? `https://cyberathon.com/multivendor/${item.multi_image}`
                          : "https://via.placeholder.com/120"
                    }
                  />

                  <div className="child">
                    <p className="para">
                      {item.product_name}
                      <br />
                      <small>
                        Color: {colorMap[item.color] || item.color}
                      </small>
                    </p>

                    {/* SIZE DISPLAY */}
                    <select name="size" id="size">
                      <option value={item.size}>
                        SIZE: {sizeMap[item.size] || item.size}
                      </option>
                    </select>

                    {customModeMap[item.cart_id] ? (
                      <input
                        type="number"
                        min="1"
                        placeholder="Qty"
                        value={
                          customQtyMap[item.cart_id] !== undefined
                            ? customQtyMap[item.cart_id]
                            : ""
                        }
                        onChange={(e) => {
                          setCustomQtyMap({
                            ...customQtyMap,
                            [item.cart_id]: e.target.value, // keep STRING
                          });
                        }}
                        onBlur={() => {
                          const rawValue = customQtyMap[item.cart_id];

                          // allow empty blur without crashing
                          if (rawValue === "" || rawValue === undefined) {
                            setCustomQtyMap({
                              ...customQtyMap,
                              [item.cart_id]: item.qty,
                            });
                            setCustomModeMap({
                              ...customModeMap,
                              [item.cart_id]: false,
                            });
                            return;
                          }

                          const qty = Number(rawValue);

                          if (qty >= 1) {
                            updateCartQuantity(item.cart_id, qty);
                          }

                          setCustomModeMap({
                            ...customModeMap,
                            [item.cart_id]: false,
                          });
                        }}
                        disabled={updatingCartId === item.cart_id}
                        style={{
                          width: "70px",
                          padding: "4px",
                          opacity: updatingCartId === item.cart_id ? 0.6 : 1,
                        }}
                      />
                    ) : (
                      <select
                        value={item.qty <= 10 ? item.qty : "custom"}
                        onChange={(e) => {
                          if (e.target.value === "custom") {
                            setCustomModeMap({
                              ...customModeMap,
                              [item.cart_id]: true,
                            });
                            setCustomQtyMap({
                              ...customQtyMap,
                              [item.cart_id]: "",
                            });
                          } else {
                            updateCartQuantity(item.cart_id, e.target.value);
                          }
                        }}
                      >
                        {[...Array(10)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>
                            Qty: {i + 1}
                          </option>
                        ))}
                        <option value="custom">10+ (Enter quantity)</option>
                      </select>
                    )}



                    {/* PRICE DISPLAY */}
                    <p id="discount">
                      <span className="price">Rs. {item.current_price}</span>

                      {item.old_price > 0 && (
                        <>
                          <s>Rs {item.old_price}</s>
                          <span className="discount-off">
                            {Math.round(((item.old_price - item.current_price) / item.old_price) * 100)}% off
                          </span>
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT SIDE */}
          <div
            className="col-lg-5 col-md-5 col-sm-12 placeOrder"
            id="placeOrder"
          >
            <div className="placeOrder">
              <div className="grid-placeOrder">
                {/* COUPONS */}
                <p className="section-title">COUPONS</p>
                <div className="coupon-row">
                  <span>
                    <b>Apply Coupons</b>
                  </span>
                  <button className="apply-btn">APPLY</button>
                </div>
                <hr />

                {/* GIFTING */}
                <p className="section-title">GIFTING & PERSONALISATION</p>
                <div className="gift-box">
                  <div>
                    <p>
                      <b>Buying for a loved one?</b>
                    </p>
                    <p className="subtext">
                      Gift Packaging and personalised message on card, Only for
                      ₹35
                    </p>
                    <button className="add-gift-btn">ADD GIFT PACKAGE</button>
                  </div>
                </div>
                <hr />

                {/* DONATION */}
                <p className="section-title">
                  SUPPORT TRANSFORMATIVE SOCIAL WORK IN INDIA
                </p>
                <label className="donate-label">
                  <input type="checkbox" />
                  <span>Donate and make a difference</span>
                </label>
                <div className="donation-buttons">
                  {[10, 20, 50, 100].map((amt) => (
                    <button key={amt} className="donate-chip">
                      ₹{amt}
                    </button>
                  ))}
                </div>
                <p className="know-more">Know More</p>
                <hr />

                {/* PRICE DETAILS */}
                <p className="section-title">PRICE DETAILS ({cart.length} Item{cart.length !== 1 ? 's' : ''})</p>
                <div className="price-row">
                  <span>Total MRP</span>
                  <span>₹{subtotal}</span>
                </div>
                <div className="price-row">
                  <span>
                    Discount on MRP <span className="know-more">Know More</span>
                  </span>
                  <span >-₹{totalDiscount}</span>
                </div>
                <div className="price-row">
                  <span>Coupon Discount</span>
                  <button className="coupon-link">Apply Coupon</button>
                </div>
                <div className="price-row">
                  <span>
                    Platform Fee <span className="know-more">Know More</span>
                  </span>
                  <span>
                    <s>₹99</s> Free
                  </span>
                </div>
                <hr />
                <div className="price-row total">
                  <span>Total Amount</span>
                  <span>₹{grandTotal}</span>
                </div>
                <button
                  className="place-order-btn"
                  onClick={handleContinue}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div className="bagfooter">
            <div className="container3">
              <img className="images" src="https://constant.myntassets.com/checkout/assets/img/footer-bank-ssl.png" />
              <img className="images" src="https://constant.myntassets.com/checkout/assets/img/footer-bank-visa.png" />
              <img className="images" src="https://constant.myntassets.com/checkout/assets/img/footer-bank-mc.png" />
            </div>

            <a className="contact" href="">
              <span>Need Help? Contact Us</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bag;